import React from "react";
import { BarChart3 } from "lucide-react";

// Show "—" for missing values (never a false zero for rate stats).
const val = (v) => (v === null || v === undefined || v === "" ? "—" : v);

function StatBlock({ title, rows, testid }) {
  const hasAny = rows.some(([, v]) => v !== null && v !== undefined && v !== "");
  return (
    <div className="bg-white border border-slate-200 rounded-sm p-4 md:p-5" data-testid={testid}>
      <div className="label-overline text-[#E63946] mb-3">{title}</div>
      <dl className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm">
        {rows.map(([k, v]) => (
          <div key={k} className="flex items-baseline justify-between border-b border-slate-100 pb-1.5">
            <dt className="text-slate-500">{k}</dt>
            <dd className="font-data text-[#0A192F]">{val(v)}</dd>
          </div>
        ))}
      </dl>
      {!hasAny && <p className="text-[11px] text-slate-400 mt-2">Populates as games are scored.</p>}
    </div>
  );
}

export default function TeamStatsTab({ stats = {}, record = {}, gamesPlayed = 0 }) {
  const s = stats || {};
  const overall = record?.overall || { w: 0, l: 0, t: 0 };

  const batting = [
    ["Team AVG", s.team_avg], ["OPS", s.ops],
    ["Runs Scored", s.runs_scored ?? 0], ["Home Runs", s.hr ?? 0],
    ["Stolen Bases", s.sb ?? 0],
  ];
  const pitching = [
    ["ERA", s.era], ["WHIP", s.whip], ["Runs Allowed", s.runs_allowed ?? 0],
  ];
  const fielding = [
    ["Fielding %", s.fielding_pct], ["Errors", s.errors ?? null],
  ];

  return (
    <div data-testid="team-stats-tab">
      <div className="flex items-center gap-2 mb-4">
        <BarChart3 className="w-4 h-4 text-[#E63946]" />
        <span className="label-overline">Team Statistics</span>
        <span className="ml-auto text-[11px] text-slate-400" data-testid="stats-sample-size">
          Sample: {gamesPlayed} game{gamesPlayed === 1 ? "" : "s"} · Record {overall.w}-{overall.l}{overall.t ? `-${overall.t}` : ""}
        </span>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        <StatBlock title="Batting" rows={batting} testid="stats-batting" />
        <StatBlock title="Pitching" rows={pitching} testid="stats-pitching" />
        <StatBlock title="Fielding" rows={fielding} testid="stats-fielding" />
      </div>
      <p className="text-[11px] text-slate-400 mt-4">
        Team totals reflect CBR-scored games only and use platform stat definitions. Individual player leaders will surface as box-score coverage grows.
      </p>
    </div>
  );
}
